import React from "react"
import { NextSeo } from "next-seo"

import Layout from "~/components/Pages/Basic"
import Markdown from "~/components/Markdown"
import TermsOfUseMarkdown from "~/content/termsOfUse.md"

const TermsOfUsePage = () => {
  return (
    <>
      <NextSeo
        title="Terms of Use | WinIt"
        description="Review the terms and conditions for using WinIt, the app for disputing and managing parking and traffic tickets."
        canonical="https://www.appwinit.com/terms-of-use"
        additionalMetaTags={[
          {
            property: "description",
            content:
              "Review the terms and conditions for using WinIt, the app for disputing and managing parking and traffic tickets.",
          },
        ]}
      />
      <Layout>
        <div style={{ textAlign: "justify" }}>
          <Markdown src={TermsOfUseMarkdown} />
        </div>
      </Layout>
    </>
  )
}

export default TermsOfUsePage
